import React from 'react';
import { appRoutes } from '@routes';
import { DonutCard } from './DonutCard.component';
import styles from '../DashboardOverviewNew.module.scss';

const EMPTY_SEGMENT = [{ name: '—', value: 1, color: '#E5E7EB' }];

const ATTENDANCE_SUMMARY_TOOLTIP = {
  description:
    "Present, leave, and absent days for the selected month, counted only across working days — holidays and non-working days aren't included.",
  calculation: {
    formula: 'Attendance % = Present days / Total working days × 100',
  },
};

export const AttendanceSummary = ({
  data,
  isLoading = false,
  reportFiltersSearch = '',
  className,
}) => {
  const hasData = Boolean(data);
  const { overall, segments } = data || { overall: 0, segments: EMPTY_SEGMENT };

  return (
    <DonutCard
      className={className || styles.attendanceCard}
      isLoading={isLoading}
      title="Attendance Summary"
      tooltip={ATTENDANCE_SUMMARY_TOOLTIP}
      chartSize={140}
      innerRadius={58}
      outerRadius={68}
      segments={segments.map((seg) => ({ ...seg, displayValue: seg.value }))}
      showLegend={hasData}
      centerValue={`${overall}%`}
      centerLabel={['Overall', 'Attendance']}
      footerLabel="View attendance report"
      footerTo={{
        pathname: appRoutes().userAttendance,
        search: reportFiltersSearch,
      }}
    />
  );
};
